import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import type { PayloadAction } from '@reduxjs/toolkit'

type PasswordLeakState = {
  isLeaked: boolean
  notNow: boolean
}

type State = {
  key: string
  isConfirmed: boolean
  passwordLeakState: PasswordLeakState
  previousState: Record<string, unknown> | null
}

const initialState: State = {
  key: '',
  isConfirmed: false,
  passwordLeakState: { isLeaked: false, notNow: false },
  previousState: null
}

export const confirmPasswordSlice = createSlice({
  name: 'confirmPassword',
  initialState,
  reducers: {
    setKey(state, action: PayloadAction<string>) {
      state.key = action.payload
    },
    setConfirmed(state, action: PayloadAction<boolean>) {
      state.isConfirmed = action.payload
    },
    setPasswordLeakState(state, action: PayloadAction<Partial<PasswordLeakState>>) {
      state.passwordLeakState = { ...state.passwordLeakState, ...action.payload }
    },
    setPreviousState(state, action: PayloadAction<Record<string, unknown>>) {
      state.previousState = action.payload
    },
    clearKey(state) {
      state.key = ''
    },
    clear() {
      return initialState
    }
  }
})

export const { setKey, setConfirmed, setPasswordLeakState, setPreviousState, clearKey, clear } = confirmPasswordSlice.actions

export const selectIsLeaked = (state: RootState) => state.confirmPassword.passwordLeakState.isLeaked

export default confirmPasswordSlice
